import React, { useCallback, useState } from 'react';

import Clickable from '../Clickable';
import Pin from '../Pin';
import ZoomableImage from '../ZoomableImage';

const UncontrolledExhibitorsInteractiveMap = (props) => {
    const { src, centerPosition, selected: selectedId, exhibitors: exhibitorsProp = [], highlightExhibitors: highlightExhibitorsProp = [], onPinClicked = () => {} } = props,
        exhibitors = exhibitorsProp.filter((exhibitor) => exhibitor?.coordinates),
        highlightExhibitors = (highlightExhibitorsProp || []).filter((exhibitor) => exhibitor?.coordinates),
        selected = exhibitors.find((exhibitor) => exhibitor.id == selectedId),
        favorites = _(exhibitors)
            .filter(Boolean)
            .reject((exhibitor) => exhibitor.id == selected?.id)
            .reject((exhibitor) => highlightExhibitors?.find((highlighted) => highlighted.id == exhibitor.id))
            .filter((exhibitor) => exhibitor.is_favorite)
            .map((e) => <Pin x={e.coordinates[0]} y={e.coordinates[1]} favorite key={e.id} onClick={(event) => handlePinClicked(event, e.id)} />)
            .value(),
        clickable = _(exhibitors)
            .filter(Boolean)
            .reject((item) => item.id == selected?.id)
            .reject((exhibitor) => highlightExhibitors?.find((highlighted) => highlighted.id == exhibitor.id))
            .filter((exhibitor) => !exhibitor.is_favorite)
            .map((e) => <Clickable x={e.coordinates[0]} y={e.coordinates[1]} key={e.id} onClick={(event) => handlePinClicked(event, e.id)} />)
            .value(),
        highlighted = _(highlightExhibitors)
            .filter(Boolean)
            .reject((exhibitor) => exhibitor.id == selected?.id)
            .map((e) => <Pin x={e.coordinates[0]} y={e.coordinates[1]} favorite key={e.id} onClick={(event) => handlePinClicked(event, e.id)} />)
            .value();

    const handleImageClicked = useCallback(
        function (offsetX, offsetY) {
            console.log('looking for exhibitor closest to ', offsetX, offsetY);
            let coords = [offsetX, offsetY],
                exhibitor = [...exhibitors].sort((a, b) => distanceBetween2Points(coords, a.coordinates) - distanceBetween2Points(coords, b.coordinates))[0];

            if (exhibitor) {
                console.log('found: ', exhibitor);
                onPinClicked(exhibitor.id);
            }
        },
        [onPinClicked, selected, exhibitors]
    );

    const handlePinClicked = useCallback(
        function (event, id) {
            event.stopPropagation();
            onPinClicked(id);
        },
        [onPinClicked]
    );

    let pin;
    if (selected) {
        pin = <Pin label={selected.name} x={selected.coordinates[0]} y={selected.coordinates[1]} spinning />;
    }

    return (
        <ZoomableImage src={src} centerPosition={centerPosition} onImageClicked={handleImageClicked}>
            {pin}
            {favorites}
            {highlighted}
            {clickable}
        </ZoomableImage>
    );
};

export default UncontrolledExhibitorsInteractiveMap;

function distanceBetween2Points(a, b) {
    // NOTE: No need to do the sqrt since this is only used for sorting purposes
    return Math.pow(a[0] - b[0], 2) + Math.pow(a[1] - b[1], 2);
}
